import { Component, OnInit } from '@angular/core';
import {NGXLogger} from 'ngx-logger';
import {
  ConfigService,
  ConnectedPatientAccount,
  FetchAndStoreRecordLocatorResultsInVaultProfile,
} from '@shared-library';
import {FastenService} from '../../services/fasten.service';

@Component({
    selector: 'connected-accounts-tab',
    templateUrl: './connected-accounts-tab.component.html',
    styleUrls: ['./connected-accounts-tab.component.css'],
    standalone: false
})
export class ConnectedAccountsTabComponent implements OnInit {
  loading = false;
  errorMessage = '';

  constructor(
    public configService: ConfigService,
    private fastenService: FastenService,
    private logger: NGXLogger,
  ) { }

  ngOnInit(): void {
    if (this.configService.systemConfig$.tefcaMode && !this.configService.vaultProfileConfig$.rlsQueryComplete) {
      this.loadConnectedAccounts();
    }
  }

  loadConnectedAccounts(forceReload = false): void {
    if (this.loading) {
      return;
    }

    if (!forceReload && this.configService.vaultProfileConfig$.rlsQueryComplete) {
      return;
    }

    this.loading = true;
    this.errorMessage = '';

    FetchAndStoreRecordLocatorResultsInVaultProfile(
      this.configService,
      () => this.fastenService.recordLocatorRegisterAndPollForStatus(),
      (taskId: string) => this.fastenService.recordLocatorResults(taskId),
    ).subscribe({
      next: () => {
        this.loading = false;
      },
      error: (error) => {
        this.logger.error('Error fetching connected TEFCA accounts', error);
        this.configService.vaultProfileConfig = {
          rlsQueryComplete: true,
        };
        this.errorMessage = 'We could not load your connected accounts right now. Please try again.';
        this.loading = false;
      }
    });
  }

  getAvailableProviderCount(vaultProfile: {
    discoveredPatientAccounts?: Record<string, unknown>;
    pendingPatientAccounts?: Record<string, unknown>;
  }): number {
    return Object.keys(vaultProfile.discoveredPatientAccounts || {}).length
      + Object.keys(vaultProfile.pendingPatientAccounts || {}).length;
  }

}
